import React, { Component } from 'react';
import _ from 'lodash'
import Charts from '../../common/Charts'
import { Row, Col, Card, Spin} from 'antd';
import { DS_CHART_TOKENS, buildReferenceZones, buildTargetLine } from '../../../utils/chartTheme';
class Hypertension extends Component {
    constructor(props) {
        super(props);
        this.state = {
            industry_data: {},
            data: [],
            total_count: 0,
            loading: false,
            hypertension_prehypertension_percent: 0,
            hypertension_prehypertension_count: 0,
            hypertensionOverall: {filters:[], config:{}},
            hypertensionGender: {filters:[], config:{}},
            hypertensionLocation: {filters:[], config:{}},
            hypertensionCompany: {filters:[], config:{}},
            baseConfig : {
              filters: [],
              config: {
                  chart: {
                      renderTo: 'container',
                      type: 'column'
                  },
                  title: {
                      text: 'Hypertension',
                      align: 'left',
                      margin: 35
                  },
                  subtitle: {text: '', align: 'left'},
                  xAxis: {},
                  yAxis: {title: {text: 'Prehypertensive/Hypertensive in %'}, 
                    labels: {
                      formatter: function() {
                        return this.value + ' %';
                      }
                    },
                    plotBands: buildReferenceZones([
                      { from: 0, to: 20, color: DS_CHART_TOKENS.green100, label: 'Optimal' },
                      { from: 20, to: 50, color: DS_CHART_TOKENS.amber100, label: 'Monitor' },
                      { from: 50, to: 100, color: DS_CHART_TOKENS.rose100, label: 'Risk' },
                    ]),
                    plotLines: [buildTargetLine({ value: 20, label: 'Target', color: DS_CHART_TOKENS.green400 })],
                    max: 100
                  },
                  plotOptions: {
                    series: {
                      stacking: 'normal'
                    }
                  },
                  credits: {
                    enabled: false
                  },
                  series: []
              }
            }
        };
        this.hypertensionLocCallback = this.hypertensionLocCallback.bind(this)
        this.hypertensionGenderCallback = this.hypertensionGenderCallback.bind(this)
        this.hypertensionCompanyCallback = this.hypertensionCompanyCallback.bind(this)
    }
    componentWillMount () {
      this.getHypertensionOverall()
      this.getHypertensionGender()
      this.getHypertensionLocation()
      this.getHypertensionCompany()    
    }

    getHypertensionCompany () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.chart.className = 'industry-hypertension-chart'
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/ht-trends/company-wise')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({hypertensionCompany: baseConfig, industry_data: response.data, allHypertensionCompany: response.data , loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }

    hypertensionCompanyCallback(filter) {
      let series = this.state.allHypertensionCompany.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allHypertensionCompany.filters
      baseConfig.config.subtitle.text = 'Industry wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({hypertensionCompany: baseConfig})
    }

    getHypertensionLocation () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/ht-trends/other-trends')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({hypertensionLocation: baseConfig, allHypertensionLoc: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }
    hypertensionLocCallback (filter) {
      let series = this.state.allHypertensionLoc.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allHypertensionLoc.filters
      baseConfig.config.subtitle.text = 'Location, Department & Shift wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
      if (a.length > 0){
        let b = a.map(a => a.data)
        // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
        b = b.filter( item => item ) // this will delete undefined from array
        if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
      }
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({hypertensionLocation: baseConfig})
    }

    getHypertensionGender () {
      let that = this;
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      this.setState({loading: true})
      baseConfig.config.subtitle.text = 'Gender wise distribution'
      window.axios.get(window.API_URL + 'corporate/dashboard/ht-trends/age-gender')
      .then(function (response) {
        baseConfig.filters = response.data.filters
        let series = response.data.series.find( object => object.filter === response.data.filters[0] );
        baseConfig.config.series = series.series
        baseConfig.config.xAxis = series.xAxis
        // baseConfig.config.yAxis = series.yAxis
        let a = series.series
        if (a.length > 0){
          let b = a.map(a => a.data)
          // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
          b = b.filter( item => item ) // this will delete undefined from array
          if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
        }
        baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
        that.setState({hypertensionGender: baseConfig, allHypertensionGender: response.data, loading: false})
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false})
      })
    }
    hypertensionGenderCallback(filter) {
      let series = this.state.allHypertensionGender.series.find( object => object.filter === filter );
      let baseConfig = _.cloneDeep(this.state.baseConfig)
      baseConfig.filters = this.state.allHypertensionGender.filters
      baseConfig.config.subtitle.text = 'Gender wise distribution'
      baseConfig.config.series = series.series
      baseConfig.config.xAxis = series.xAxis
      // baseConfig.config.yAxis = series.yAxis
      let a = series.series
        if (a.length > 0){
        let b = a.map(a => a.data)
        // b = b.flat()  only supports latest browsers
          b = Array.prototype.concat(...b)
        b = b.filter( item => item ) // this will delete undefined from array
        if (b.length > 0){
            baseConfig.config.yAxis["max"] = Math.max(...b)
          }
      }  
      baseConfig.config.plotOptions = {column: {maxPointWidth: 31}}
      this.setState({hypertensionGender: baseConfig})
    }

    getHypertensionOverall () {
      let that = this
      let baseConfig = {
        filters: [],
        config: {
          chart: {
              plotBackgroundColor: null,
              plotBorderWidth: null,
              plotShadow: false,
              type: 'pie',
              className: 'overall-hypertension-chart'
          },
          title: {
              text: 'Hypertension',
              align: 'left'
          },
          subtitle: {
              text: '',
              align: 'left'
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
              pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  dataLabels: {
                      enabled: true,
                      distance: 20,
                      format: '{point.percentage:.1f} %',
                      style: {
                          color: 'black'
                      },
                      connectorColor: 'silver'
                  },
                  showInLegend: true
              }
          },
          credits: {
            enabled: false
          },
          series: [{
              name: 'Employees',
              data: []
          }]
        }
      }
      window.axios.get(window.API_URL + 'corporate/dashboard/ht-trends/overall')
      .then(function (response) {
        baseConfig.config.series[0].data = response.data.series
        baseConfig.config.subtitle.text = response.data.total_count + " Users"
        let hypertension_percent = 0
        let prehypertension_percent = 0
        let hypertension_prehypertension_percent = 0
        let hypertension_prehypertension_count = 0
        if (response.data.series.length > 0){
          let hypertension_data = response.data.series.find( a => a.name === 'Hypertensive' );
          if (hypertension_data){
            hypertension_percent = hypertension_data.y ? hypertension_data.y : 0
          }
          let prehypertension_data = response.data.series.find( a => a.name === 'Prehypertensive' );
          if (prehypertension_data){
            prehypertension_percent = prehypertension_data.y ? prehypertension_data.y : 0
          }
          hypertension_prehypertension_percent = (hypertension_percent + prehypertension_percent).toFixed(1)
          hypertension_prehypertension_count = ((response.data.total_count*hypertension_prehypertension_percent)/100).toFixed(0)
          hypertension_prehypertension_percent = parseFloat(hypertension_prehypertension_percent).toFixed(0)
        }
        that.setState({hypertensionOverall: baseConfig, data: response.data.series, total_count: response.data.total_count, hypertension_prehypertension_percent: hypertension_prehypertension_percent, hypertension_prehypertension_count: hypertension_prehypertension_count})
      })
      .catch(function (error) {
        console.log(error);
      })
    }
    render () {
        return (
            <div id="dashboard-hypertension-chart" className="gutter-example">
              <Spin spinning={this.state.loading}>
                <Card>
                  <Row gutter={16}>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts filters={this.state.hypertensionOverall.filters} config={this.state.hypertensionOverall.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts callback={this.hypertensionGenderCallback}
                              filters={this.state.hypertensionGender.filters} 
                              config={this.state.hypertensionGender.config}/>
                          </div>
                      </Col>
                  </Row>
                </Card>  
                <br></br>
                <Card>  
                  <Row gutter={16}>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts callback={this.hypertensionLocCallback}
                              filters={this.state.hypertensionLocation.filters} 
                              config={this.state.hypertensionLocation.config}/>
                          </div>
                      </Col>
                      <Col span={2}/>
                      <Col className="gutter-row" md={11} sm={24}>
                          <div className="gutter-box">
                              <Charts callback={this.hypertensionCompanyCallback}
                              filters={this.state.hypertensionCompany.filters} 
                              config={this.state.hypertensionCompany.config}/>
                          </div>
                      </Col>
                  </Row>
                </Card>  
                <br></br>
                <input type='hidden' id="hypertension_prehypertension_percent" value={this.state.hypertension_prehypertension_percent} />
                <input type='hidden' id="hypertension_prehypertension_count" value={this.state.hypertension_prehypertension_count} />
                <input type='hidden' id="hypertension_trends_data" value={JSON.stringify(this.state.data)} />
                <input type='hidden' id="hypertension_trends_count" value={this.state.total_count} />
                <input type='hidden' id="hypertension_trends_industry_data" value={JSON.stringify(this.state.industry_data)} />
              </Spin>    
            </div>
        )
    }
}
export default Hypertension;
